// extracted by mini-css-extract-plugin
export default {"site":"SiteBlock_site_Q9Ewf","inner":"SiteBlock_inner_rKsVi"};